import React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {jssPreset, StylesProvider} from '@material-ui/core/styles';
import rtl from 'jss-rtl';
import {create} from 'jss';
import MessengerNavigation from "../Views/MessengerNavigation/MessengerNavigation";
import Home from "../Views/Home/Home";
import PrivacyPolicy from "../Views/PrivacyPolicy/PrivacyPolicy";
import DeliveriesDashboardContainer from "../Redux/containers/DeliveriesDashboardContainer";
import Login from "../Views/Login/Login";
import Businesses from "../Views/Businessees/Businesses";
import AddBusiness from "../Views/AddBusiness/AddBusiness";
import SendSMS from "../Views/SendSMS/SendSMS";
import RedirectToAppDownload from "../Views/RedirectToAppDownload/RedirectToAppDownload";
import Clown from "../Views/Clown/Clown";
import AllStatus from "../Views/AllStatus/AllStatus";
import OrderTracker from "../Views/OrderTracker/OrderTracker";
import DeleteOrders from "../Views/DeleteOrders/DeleteOrders";
import Logout from "../Views/Logout/Logout";

// Configure JSS
const jss = create({plugins: [...jssPreset().plugins, rtl()]});

function Routing() {
    return (
        <StylesProvider jss={jss}>
            <BrowserRouter>
                <Switch>
                    <Route path='/t/:id' component={OrderTracker}/>
                    <Route path='/navigate/:id' component={MessengerNavigation}/>
                    <Route path='/privacypolicy' component={PrivacyPolicy}/>
                    <Route path='/login' component={Login}/>
                    <Route path='/logout' component={Logout}/>
                    <Route exact path="/ship/:bid" component={DeliveriesDashboardContainer}/>
                    <Route path='/ship' component={Businesses}/>
                    <Route path='/addbusiness' component={AddBusiness}/>
                    <Route path='/sendsms' component={SendSMS}/>
                    <Route path='/deleteorders' component={DeleteOrders}/>
                    <Route path='/allstatus' component={AllStatus}/>
                    <Route path='/clown' component={Clown}/>
                    <Route path='/app' component={RedirectToAppDownload}/>
                    <Route component={Home}/>
                </Switch>
            </BrowserRouter>
        </StylesProvider>
    );
}

export default Routing;

